export class email {
    fromEmail: string;
    message: string;
    fName: string;
    lName: string;
    reason: string;
    company: string;
    reciept: string;
}